import UAParser from "ua-parser-js";

export function detectPlatform() {
  let osName = (new UAParser()).getOS().name || "";
  osName = osName.toLowerCase().trim().replace(/\s/g, '');
  // if (osName == "macos" && isIPad()) {
  //   osName = "ios";
  // }
  return osName;
}

export function IsAndroidQQ() {
  if (navigator.userAgent.indexOf("Android ") >= 0 && navigator.userAgent.indexOf(" QQ/") >= 0) {
    return true;
  }
  return (detectPlatform() === 'android' && /MQQBrowser/i.test(navigator.userAgent) && /QQ/i.test((navigator.userAgent).split('MQQBrowser').join("")));
}

export function IsIosQQ() {
  return detectPlatform() === 'ios' && / QQ/i.test(navigator.userAgent);
}

export function isMobileQQ() {
  return IsIosQQ() || IsAndroidQQ();
}

if (IsIosQQ()) {
  document.body.className = (document.body.className || "") + " ios-qq";
}

if (isMobileQQ()) {
  document.body.className = (document.body.className || "") + " platform-mobile-qq";
}

function isIPad() {
  if (window['isIpadResult'] != undefined) {
    return window['isIpadResult'];
  }
  var canvas = document.createElement("canvas");
  if (canvas != null) {
    var context = canvas.getContext("webgl") || canvas.getContext("experimental-webgl") as any;
    if (context) {
      var info = context.getExtension("WEBGL_debug_renderer_info");
      if (info) {
        var renderer = context.getParameter(info.UNMASKED_RENDERER_WEBGL);
        window['isIpadResult'] = (renderer.indexOf("Apple") >= 0) && (renderer !== "Apple M1");
        return window['isIpadResult'];
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/useragent.ts